export const math = (function () {
    function round(n, p) {
        return parseFloat(n.toFixed(p));
    }

    function combinations(n, k) {
        let max, result, i;
        if (n < 0) {
            if (console)
                console.log('Math.combinations error: positive integer value expected in first argument');
            return 0;
        }
        if (k < 0) {
            if (console)
                console.log('Math.combinations error: positive integer value expected in second argument');
            return 0;
        }
        if (k > n) {
            if (console)
                console.log('Math.combinations error: second argument must be less than or equal to first argument');
            return 0;
        }

        max = Math.max(k, n - k);
        result = 1;
        for (i = 1; i <= n - max; i++) {
            result = result * (max + i) / i;
        }

        return result;
    }

    function randomInt(r, s) {
        if (arguments.length === 2) {
            return r + Math.floor(Math.random() * (s - r));
        }

        return Math.floor(Math.random() * r);
    }

    return {
        round: round,
        combinations: combinations,
        randomInt: randomInt,
    };
})();

export var Html = (function () {
    function FormSubmit(_window, url, data, IsHttpGet = true, IsCordova = false) {
        if(IsCordova) {
            CordovaRedirect(url, data, IsHttpGet);
            return;
        }

        if (IsHttpGet) {
            let queryString = "";
            if(typeof data === "object" && !!data){
                let _tmp = [];
                
                Object.keys(data).forEach(key => {
                    _tmp.push(key + "=" + data[key]);
                });
                if(_tmp.length > 0)
                    queryString = "?" + _tmp.join("&");
            }

            _window.location.replace(url + queryString);
        } else {
            let getDiv = _window.document.getElementById('formDiv');
            if (getDiv)
              getDiv.remove();

            let postData = typeof data === "object" && !!data ?
                Object.keys(data).map(function (key, index) { return `<input type='hidden' name='${key}' value='${data[key]}'>`; }).join('') :
                "";

            //不要換行, 不然會噴EOF錯誤
            let html = `<form style='display: none;' id='form' method='post' action='${url}'>${postData}</form>`;
            
            let temp = document.createElement('div');
            temp.id = 'formDiv';
            temp.style.display = 'none';
            _window.document.body.appendChild(temp);
            _window.document.getElementById('formDiv').innerHTML = html;
            _window.document.getElementById('form').submit();
        }

    }

    function CordovaRedirect(url, data, IsHttpGet){
        let outSideURL =  new URL(window.localStorage["API_PROXY"]);
        outSideURL.pathname = "redirect.html";
        outSideURL.searchParams.append("_IsHttpGet", IsHttpGet ? "1" : "0");
        outSideURL.searchParams.append("_URL", encodeURIComponent(url));

        if(typeof data === "object" && !!data){
            Object.keys(data).forEach(key => {
                outSideURL.searchParams.append(key,  data[key]);
            });
        }
        window.PresentAlertConfirm(outSideURL.toString());
    }

    function CordovaBrowserEventCallBack(event, _window) {
        //weixin微信、alipays支付寶、upwrp(銀聯、雲閃付)
        if (event.url.match("weixin://") || event.url.match("alipays://") || event.url.match("upwrp://")) {
            var openUrl = event.url.replace(/^http:\/\//, ""); //移除Cordova自動添加的http://
            window.open(openUrl, "_system", 'location=no,closebuttoncaption=结束');

            _window.close();
        }

    }

    function htmlEncode (value) {
        //建立一個在memory中的div，寫入值，並以html()方式取出
        return $('<div/>').text(value).html();
    }

    function htmlDecode (value) {
        return $('<div/>').html(value).text();
    }

    return {
        FormSubmit: FormSubmit,
        HtmlEncode: htmlEncode,
        HtmlDecode: htmlDecode
    };
})();

export var String = (function () {
    function setParams (text, params) {
        return text.replace(/{(\d+)}/g, (match, number) => params[number] != undefined ? params[number] : match);
    }

    return {
        setParams: setParams
    };
})();